import { useCompassCard } from '@scale/compass-ui/store';
import {
  CompassCardComponent,
  CompassCardComponentProps,
} from 'react-scale/corp/views/DataCompassV2/types';
import {
  SaveToSnowflakeContext,
  SaveToSnowflakeWriteMode,
} from '@scale/genai-compass-shared/cards/save_to_snowflake';
import useSaveToSnowflake from './useSaveToSnowflake';
import { Text, Flex, TextField, RadioGroup } from '@scale/scaleui-radix';
import { SaveToSnowflakeInstructions } from './SaveToSnowflakeInstructions';

const SaveToSnowflakeComponent: CompassCardComponent = ({ index }: CompassCardComponentProps) => {
  const { card } = useCompassCard(index);
  const { setTableName, setWriteMode } = useSaveToSnowflake(index);
  const context = card.defaultContext as SaveToSnowflakeContext;

  return (
    <Flex direction="row" gap="2">
      <div className="w-1/2">
        <SaveToSnowflakeInstructions />
      </div>
      <Flex direction="column" gap="2" className="flex-1">
        <Text>Table Name</Text>
        <TextField.Root
          id="table-name-input"
          value={context.tableName}
          onChange={e => setTableName(e.target.value)}
          placeholder="Enter table name"
          className="w-full"
        />
        <RadioGroup.Root
          defaultValue={context.writeMode}
          name="Write Mode"
          onValueChange={value => setWriteMode(value as SaveToSnowflakeWriteMode)}
        >
          <RadioGroup.Item value={SaveToSnowflakeWriteMode.APPEND}>Append</RadioGroup.Item>
          <RadioGroup.Item value={SaveToSnowflakeWriteMode.OVERWRITE}>Overwrite</RadioGroup.Item>
        </RadioGroup.Root>
      </Flex>
    </Flex>
  );
};

export default SaveToSnowflakeComponent;
